<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>
<div class="filter-dropdown-container-dis">
  <app-dropdown [options]="districtOptions" [(selectedValue)]="selectedDistrict"
    customClass="districts-district-dropdown" (selectedValueChange)="onDistrictChange($event)" placeholder="District"
  label="District" [showFloatingLabel]="true"></app-dropdown>

  <app-dropdown [options]="insapOptions" [(selectedValue)]="selectedInSap" customClass="submitter-type-dropdown"
    (selectedValueChange)="onInSapChange($event)" placeholder="In SAP" label="In SAP"
  customClass="districts-small-dropdown" [showFloatingLabel]="true"></app-dropdown>


  <app-datepicker [(ngModel)]="selectedScheduledDate" (onSelectChange)="onScheduledDateChange($event)"
  [inputlabel]="'Sched Date'"></app-datepicker>

  <app-dropdown [options]="typeOptions" customClass="districts-small-dropdown-adjustment"
    [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)" aria-label="Type" placeholder="Type"
  label="Type" [showFloatingLabel]="true"></app-dropdown>


  <div>
    <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>
    <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
  </div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" [totalRecords]="totalRecords" (onAction2ButtonClicked)="onReloadClicked()"
  [actionButtons]="actionButtons" (pageChanged)="onPageChanged($event)" (sortClicked)="onSortClicked($event)"
(onSearchText)="onSearchText($event)" (onCellClicked)="onCellClicked($event)"></app-table>